(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-data/funds/assets/javascripts/funds-actions.js') >= 0) return;  svs.modules.push('/components/marketplace-data/funds/assets/javascripts/funds-actions.js');
"use strict";


const _RTK = RTK,
  createAsyncThunk = _RTK.createAsyncThunk;

const fetchJackpots = createAsyncThunk('fetchJackpots', async _ref => {
  let callback = _ref.callback,
    products = _ref.products;
  try {
    const jackpots = await svs.content.shared.getJackpots(products);
    callback(null, jackpots);
    return jackpots;
  } catch (error) {
    callback(error);
    throw error;
  }
});

const fetchFunds = createAsyncThunk('fetchFunds', _ref2 => {
  let callback = _ref2.callback,
    products = _ref2.products;
  return new Promise((resolve, reject) => {
    try {
      const funds = svs.components.lbUtils.funds.getFunds({
        products
      });
      callback(null, funds);
      resolve(funds);
    } catch (error) {
      callback(error);
      reject(error);
    }
  });
});
setGlobal('svs.components.marketplaceData.funds.actions', {
  fetchJackpots,
  fetchFunds
});

 })(window);